import { Component, EventEmitter, Input, Output, Self } from '@angular/core';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { CredentialType } from 'enums/CredentialType';
import { InputType } from 'enums/InputType';
import { VariantListModel } from 'models/generated/Entities.GormCrm.VariantList';
import { VariantListOptionModel } from 'models/generated/Entities.GormCrm.VariantListOption';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CredentialRequired } from 'services/credential.service';
import { FormValidationService } from 'services/form-validation.service';

@Component({
	selector: 'select-variant-options',
	templateUrl: './select-variant-options.component.html',
	providers: [FormValidationService],
	imports: [Layout, CustomInputComponent, TranslatePipe, ListView]
})
@CredentialRequired(CredentialType.ProductsAccessFull)
export class SelectVariantOptionsComponent {

	private pristine = true;
    private _variantLists?: VariantListModel[];
	variantListOptions?: VariantListOptionModel[];
	@Input()
	set variantLists(lists: VariantListModel[] | undefined) {
		this._variantLists = lists;
		this.variantListOptions = lists?.flatMap(list => list.variantListOptions) ?? [];
	}
	get variantLists() { return this._variantLists; }
	showSaveButton = false;
	inputType = InputType;
	selectedVariantOptions: string[] = [];
	@Output() selectionConfirmed = new EventEmitter<string[]>();
	
	constructor(@Self() private readonly formValidation: FormValidationService) {
		this.formValidation.fieldStateChanged(this, true, true);
	}

	markAsPristine() { this.pristine = true; }

	toggleAll(variantList: VariantListModel) {

		const missingVariantOptions = variantList.variantListOptions.filter(option => !this.selectedVariantOptions.includes(option.id!));

		if (missingVariantOptions.length === 0) {
			// all options are selected, remove all
			this.selectedVariantOptions = this.selectedVariantOptions.filter(id => !variantList.variantListOptions.some(option => option.id === id));
		}
		else {
			// some options are not selected, add all
			this.selectedVariantOptions = this.selectedVariantOptions.concat(missingVariantOptions.map(option => option.id!));
		}

		this.pristine = false;
		this.refreshValidation();
	}

	isSelected(option: VariantListOptionModel) {
		return this.selectedVariantOptions.some(selectedId => selectedId === option.id);
	}
	toggle(option: VariantListOptionModel, selected: boolean) {
		if (selected && !this.selectedVariantOptions.includes(option.id!)) {
			this.selectedVariantOptions.push(option.id!);
		} else {
			this.selectedVariantOptions = this.selectedVariantOptions.filter(id => id !== option.id);
		}

		this.pristine = false;
		this.refreshValidation();
	}

	refreshValidation() {
		let valid = true;
		this.variantLists?.forEach(variantList => {
			if (!variantList.variantListOptions.some(option => this.selectedVariantOptions.includes(option.id!))) valid = false; // Not valid if any variant list has no selected options
		});
		this.formValidation.fieldStateChanged(this, valid, this.pristine);
	}

	getListName = (option: VariantListOptionModel) => option.variantList?.name ?? '';

	saveSelectedVariants() {
		this.selectionConfirmed.emit(this.selectedVariantOptions);
	}
}
